export const sweetAlertConstants = {
  SUCCESS: 'SWEET_ALERT_SUCCESS',
  DANGER: 'SWEET_ALERT_DANGER',
  WARNING: 'SWEET_ALERT_WARNING',
  INFO: 'SWEET_ALERT_INFO',
  CLEAN: 'SWEET_ALERT_CLEAN',
  CLEAR: 'SWEET_ALERT_CLEAR'
};
